import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';

// Import translation files
import commonIt from '../locales/it/common.json';
import commonEn from '../locales/en/common.json';
import commonDe from '../locales/de/common.json';
import commonFr from '../locales/fr/common.json';
import commonEs from '../locales/es/common.json';
import pagesIt from '../locales/it/pages.json';
import pagesEn from '../locales/en/pages.json';
import pagesDe from '../locales/de/pages.json';
import pagesFr from '../locales/fr/pages.json';
import pagesEs from '../locales/es/pages.json';
import componentsIt from '../locales/it/components.json';
import componentsEn from '../locales/en/components.json';
import componentsDe from '../locales/de/components.json';
import componentsFr from '../locales/fr/components.json';
import componentsEs from '../locales/es/components.json';
import questionsIt from '../locales/it/questions.json';
import questionsEn from '../locales/en/questions.json';
import questionsDe from '../locales/de/questions.json';
import questionsFr from '../locales/fr/questions.json';
import questionsEs from '../locales/es/questions.json';
import errorsIt from '../locales/it/errors.json';
import errorsEn from '../locales/en/errors.json';
import errorsDe from '../locales/de/errors.json';
import errorsFr from '../locales/fr/errors.json';
import errorsEs from '../locales/es/errors.json';

const resources = {
  it: {
    common: commonIt,
    pages: pagesIt,
    components: componentsIt,
    questions: questionsIt,
    errors: errorsIt,
  },
  en: {
    common: commonEn,
    pages: pagesEn,
    components: componentsEn,
    questions: questionsEn,
    errors: errorsEn,
  },
  de: {
    common: commonDe,
    pages: pagesDe,
    components: componentsDe,
    questions: questionsDe,
    errors: errorsDe,
  },
  fr: {
    common: commonFr,
    pages: pagesFr,
    components: componentsFr,
    questions: questionsFr,
    errors: errorsFr,
  },
  es: {
    common: commonEs,
    pages: pagesEs,
    components: componentsEs,
    questions: questionsEs,
    errors: errorsEs,
  },
};

i18n
  .use(LanguageDetector) // Detects user language from browser
  .use(initReactI18next) // Passes i18n down to react-i18next
  .init({
    resources,
    fallbackLng: 'it', // Default language
    lng: 'it', // Initial language
    debug: false, // Set to true for debugging
    
    interpolation: {
      escapeValue: false, // React already escapes values
    },
    
    defaultNS: 'common',
    ns: ['common', 'pages', 'components', 'questions', 'errors'],
    
    react: {
      useSuspense: false, // Set to true if you want to use Suspense
    },
  });

export default i18n;

